import {
  EmCalculatorConfiguration,
  EmCalculatorStore,
  EmElements,
  EmLevel,
  FormApi,
  WorksheetResult,
  fetchRequest,
  formApi,
  worksheetMessage,
} from '../../core'

type EmInterventionsData = {
  severities: EmLevel[]
  interventions: EmLevel[]
}

type EmInterventionsRequestData = {
  locationCode: string
  department: string
  interventionsEmLevels: number[]
  severitiesEmLevels: number[]
}
type EmInterventionsResponse = {
  suggestedEM: number
}

export const calculatemEmOutpatientFacilityRequest = fetchRequest<
  EmInterventionsRequestData,
  WorksheetResult<EmInterventionsResponse>
>({
  method: 'post',
  body: (args) => worksheetMessage(args, 'calculateemoutpatientfacility', 'em-calculator'),
})

export type EmInterventionsApi = {
  config: EmCalculatorConfiguration
  form: FormApi<EmInterventionsData>
  set: (values: EmInterventionsData) => void
  clear: () => void
}
type EmInterventionsApiProps = {
  locationCode: string
  departmentCode: string
  calculator: EmCalculatorStore
}
export function emInterventionsApi({
  locationCode,
  departmentCode,
  calculator,
}: EmInterventionsApiProps): EmInterventionsApi {
  const { config } = calculator.getState()
  const { severities, interventions } = config

  const emptyValues: EmInterventionsData = {
    severities: [],
    interventions: [],
  }
  const searchWidth = 340
  const searchHeight = 600
  const optionWidth = 175
  const optionHeight = 100

  const update = async (values: EmInterventionsData) => {
    if (!values) return

    const { severities, interventions } = values
    if (!severities.length || !interventions.length) return

    const resp = await calculatemEmOutpatientFacilityRequest({
      locationCode,
      department: departmentCode,
      interventionsEmLevels: interventions.map((a) => a.emLevel),
      severitiesEmLevels: severities.map((a) => a.emLevel),
    })

    if (resp?.success) {
      const { suggestedEM } = resp.result
      calculator.setState({ result: { calculatedEM: suggestedEM, severities, interventions } as any })
    } else {
      calculator.setState({ errorMessages: resp?.errors } as any)
    }
  }
  function resetLevels() {
    severities.forEach((a) => (a.selected = false))
    interventions.forEach((a) => (a.selected = false))
  }
  const onChange = (levels: EmLevel[], isSeverity = true) => {
    let list = levels || []

    if (list.length) {
      list.forEach((level: EmLevel) => {
        level.selected = true
      })
    } else {
      const conf = isSeverity ? config.severities : config.interventions
      conf.forEach((level: EmLevel) => {
        level.selected = false
      })
    }

    setTimeout(() => {
      console.info('update', form.values.getState().value, 'patch', levels)
      update(form.values.getState().value)
    }, 100)
  }

  const listLabel = (a: EmLevel) => a.emLevel + ' - ' + a.description

  const equals = (a: EmLevel, b: EmLevel) => b.emLevel === a.emLevel && b.description === a.description
  const form = formApi<EmInterventionsData>({
    values: emptyValues,
    fields: {
      severities: {
        list: severities || [],
        onChange: (v) => onChange(v, true),
        equals,
        listLabel,
        searchWidth,
        searchHeight,
        optionWidth,
        optionHeight,
      },
      interventions: {
        list: interventions || [],
        onChange: (v) => onChange(v, false),
        equals,
        listLabel,
        searchWidth,
        searchHeight,
        optionWidth,
        optionHeight,
      },
    },
    valid: (values) => values.severities.length > 0 && values.interventions.length > 0,
    resetValues: () => emptyValues,
    onSubmit: async (values) => {
      update(values)
    },
  })

  const set = (values: EmInterventionsData) => {
    form.setValues(values)
  }
  const clear = () => {
    resetLevels()
    form.setValues(emptyValues)
  }

  function updateInterventions({ severities, interventions }: EmElements) {
    clear()

    const selectedSeverities = severities
      .map((a) => config.severities.find((b) => equals(a, b)))
      .filter((a) => a)

    const selectedInterventions = interventions
      .map((a) => config.interventions.find((b) => equals(a, b)))
      .filter((a) => a)

    selectedSeverities.forEach((a) => (a.selected = true))
    selectedInterventions.forEach((a) => (a.selected = true))

    setTimeout(() => {
  //  form.controls.severities.value.setState({ value: selectedSeverities.slice()});
   // form.controls.interventions.value.setState({ value: selectedInterventions.slice()});
    
    form.setValues({ severities: selectedSeverities, interventions: selectedInterventions })
    }, 400);
  }
  calculator.setState({ updateInterventions })

  return {
    config,
    form,
    set,
    clear,
  }
}
